import http from '../http'

/**
 * 创建项目
 * @param {Object} data 项目数据
 * @returns {Promise} 返回创建结果
 */
export function createProject(data) {
  return http.post('/projects', data)
}

/**
 * 更新项目
 * @param {Number|String} id 项目ID
 * @param {Object} data 项目数据
 * @returns {Promise} 返回更新结果
 */
export function updateProject(id, data) {
  return http.put(`/projects/${id}`, data)
}

/**
 * 删除项目
 * @param {Number|String} id 项目ID
 * @returns {Promise} 返回删除结果
 */
export function deleteProject(id) {
  return http.delete(`/projects/${id}`)
}

/**
 * 获取项目详情
 * @param {Number|String} id 项目ID
 * @returns {Promise} 返回项目详情
 */
export function getProjectById(id) {
  return http.get(`/projects/${id}`)
}

/**
 * 分页查询项目
 * @param {Object} params 查询参数
 * @param {Number} [params.page] - 页码（从0开始）
 * @param {Number} [params.size] - 每页数量
 * @param {String} [params.sortBy] - 排序字段
 * @param {String} [params.sortDir] - 排序方向
 * @returns {Promise} 返回项目列表和分页信息
 */
export function queryProjectsPage(params = {}) {
  return http.get('/projects/page', { params })
}

/**
 * 条件查询项目
 * @param {Object} params 查询参数
 * @param {String} [params.projectName] - 项目名称
 * @param {Number} [params.unitInfoId] - 单位ID
 * @param {Number} [params.userId] - 用户ID
 * @param {Number} [params.page] - 页码
 * @param {Number} [params.size] - 每页数量
 * @param {String} [params.sortBy] - 排序字段
 * @param {String} [params.sortDir] - 排序方向
 * @returns {Promise} 返回项目列表和分页信息
 */
export function searchProjects(params = {}) {
  return http.get('/projects/search', { params })
}

/**
 * 根据单位查询项目
 * @param {Number|String} unitId 单位ID
 * @returns {Promise} 返回项目列表
 */
export function getProjectsByUnit(unitId) {
  return http.get(`/projects/unit/${unitId}`)
}

/**
 * 根据用户查询项目
 * @param {Number|String} userId 用户ID
 * @returns {Promise} 返回项目信息
 */
export function getProjectByUser(userId) {
  return http.get(`/projects/user/${userId}`)
}

/**
 * 更新项目状态
 * @param {Number|String} id 项目ID
 * @param {String} status 新状态
 * @returns {Promise} 返回更新结果
 */
export function updateProjectStatus(id, status) {
  return http.put(`/projects/${id}/status?status=${status}`)
}

/**
 * 获取所有项目列表（不分页）
 * @returns {Promise} 返回项目列表
 */
export function getAllProjects() {
  return http.get('/projects')
}

export default {
  createProject,
  updateProject,
  deleteProject,
  getProjectById,
  queryProjectsPage,
  searchProjects,
  getProjectsByUnit,
  getProjectByUser,
  updateProjectStatus,
  getAllProjects
}
